module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1278.b7f60749.png";